import { useContext } from "react";
import { interfaces } from "inversify";
import { InversifyContext } from "@presentation/components/dependencyInjection/ContainerProvider";

/**
 * Defines the hook used to resolve a dependency in a component.
 */
export function useInjection<T>(identifier: interfaces.ServiceIdentifier<T>): T {
  const { container } = useContext(InversifyContext);
  if (!container) {
    throw new Error("The container should not be null");
  }
  try {
    return container.get<T>(identifier);
  } catch (e) {
    return container.resolve<T>(identifier as interfaces.Newable<T>);
  }
}
